import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import { Contactform } from './Contactform'
import BrochureForm from './BrochureFrom'
import SlideButton from './SlideButton';
import Popup from './Popup';
import droneplotview from "../images/DRONE IMAGE TOP VIEW.png";
import plotarea from "../images/UNICORN AEROCITY 9.png"
import plotarea_uniocornaerocity from "../images/UNICORN AEROCITY 15.jpg"
import "./Home.css";
import aerocity from "../images/aerocity_photo.jpeg"
import 'react-html5video/dist/styles.css';
import videoFile from "../images/LOCATION VIDEO .mp4";
import uniocornaerocity from "../images/GATE DESIGN.png"
import plotairportkolkata from "../images/Unicorn Aerocity Mobile  Brochure (2)_00001.jpg"
import plotarea_kolkata from "../images/unicorn-aerocity view.jpeg";
import plotarea_uniocornaerocityland from "../images/plot airport.jpeg"
import dreamhouseplot from "../images/dream house plot.jpeg"
import front from "../images/FRONT .png";
import plot from "../images/plot.jpeg"
import Gallery from './Gallery'
import ScrollToTop from "react-scroll-to-top";
import Projectpage from './Projectpage'
import meethomeowner from "../images/meet our home owner.jpg";
import PlotOwner from './PlotOwner'
import NearbyPlaces from './NearbyPlaces'


function Home() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />

      <br />
      <ScrollToTop smooth top="100" color="maroon" />
      <Popup />
      <div className="dreamprojectnovestagroup">
        <div className="album py-2">
          <div className="container">
            <div className="row ">
              <div className="col-md-7">
                <Slider />
              </div>
              <div className="col-md-5">
                <Contactform />
              </div>
            </div>
          </div>
        </div>
        <center>

          <a href="Riverside_Investment" class="highlight-btn">
            Riverside Investment Opportunity | Own a Resort. Earn More <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
              <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
            </svg>
          </a>

        </center>
        <br />
      </div>
      <div className="album py-2">
        <div className="container">
          <center>
            <h2 style={{ color: "#19514f" }}>Unicorn Aerocity Project</h2>
            <p>Watch the video to get basic information about Unicorn Aerocity and the surrounding location.</p>

            <p style={{ color: "#1a7593" }}><small>Unicorn Aerocity Plot Area Drone View</small></p>
          </center>
        </div>
      </div>
      <div className="album py-1">
        <div className="container">
          <div className="row ">
            <div className="col-md-12 mt-0">

              <video width="100%" controls autoPlay loop muted>
                <source src={videoFile} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>


          </div>
        </div>
      </div>


      <div className="album py-2">
        <div className="container">
          <div className="row ">
            <div className="col-md-3 mt-2">
              <img src={droneplotview} className="card-img-top" alt="droneplotview" />
            </div>
            <div className="col-md-3 mt-2">
              <img src={plotarea} className="card-img-top" alt="plotarea" />

            </div>
            <div className="col-md-3 mt-2">

              <img src={plotarea_uniocornaerocity} className="card-img-top" alt="plotarea_uniocornaerocity" />

            </div>
            <div className="col-md-3 mt-2">

              <img src={front} className="card-img-top" alt="front_uniocornaerocity" />

            </div>
          </div>
        </div>
      </div>


      <BrochureForm />
      <SlideButton />
      <Projectpage />

      <div className='airportkolkataplot'>
        <br />
        <div className="album py-1">
          <div className="container">
            <center>
              <h2 style={{ color: "#19514f" }}>Unicorn Aerocity -Our Happy Plot Owner</h2>
              <p>Our customers appreciate the clear documentation, prime location, and transparent pricing, which make their buying journey smooth and stress-free. From booking to handover, we ensure complete support, timely updates, and a professional experience</p>

            </center>
          </div>
        </div>
        <PlotOwner />
        <br />
      </div>
      <br />

      <div className="album py-1">
        <div className="container">
          <img src={meethomeowner} className="d-block w-100" alt="meethomeowner" />

        </div>
      </div>
      <div className="album py-1">
        <div className="container">
          <div className="row ">
            <div className="col-md-6 mt-2">
              <div className='radius'>
                <img src={uniocornaerocity} className="card-img-top" alt="plotarea_uniocornaerocity" />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <div className='radius'>
                <img src={plotarea_uniocornaerocity} className="card-img-top" alt="plotarea_uniocornaerocity" />
              </div>
            </div>

            <div className="col-md-4 mt-2">
              <div className='radius img-card'>
                <img src={plotarea_kolkata} className="card-img-top" alt="plotarea_uniocornaerocity" />
              </div>
            </div>
            <div className="col-md-4 mt-2">
              <div className='radius img-card'>
                <img src={plotarea_uniocornaerocityland} className="card-img-top" alt="plotarea_uniocornaerocity" />
              </div>
            </div>
            <div className="col-md-4 mt-2">
              <div className='radius'>
                <img src={dreamhouseplot} className="card-img-top" alt="plotarea_uniocornaerocity" />
              </div>
            </div>


          </div>
        </div>
      </div>
      <br />
      <div className="album py-1">
        <div className="container">
          <center>
            <h1 style={{ color: "#0f3987" }} className='unicorn'> Unicorn Aerocity –<b style={{ color: "#204453" }}> Premium Plots Near Kolkata Airport</b></h1>
          </center>
        </div>
      </div>
      <div className="album py-0">
        <div className="container">
          <div className="row ">
            <div className="col-md-4 mt-1">

              <img src={plotairportkolkata} className="card-img-top" alt="plotairportkolkata" />
            </div>
            <div className="col-md-4 mt-1">

              <img src={plot} className="card-img-top" alt="plotairportkolkata" />
            </div>
            <div className="col-md-4 mt-1">

              <img src={aerocity} className="card-img-top" alt="plotairportkolkata" />
            </div>
          </div>
        </div>

      </div>
      <br />
      <div className="album py-1">
        <div className="container">
          <h1 style={{ color: "#0e484d" }}><b>Gallery</b></h1>
        </div>
      </div>
      <Gallery />
      <br />
      <div style={{ color: "white", padding: "14px;", margin: 10 }} className="fixed-bottom "> <a style={{ color: "white" }} href="Aerocityphase2" className="unicornaerocityphaseII" >  Unicorn Aerocity Phase II – Now Launched <div className="spinner-grow text-light spinner-grow-sm" role="status">
        <span className="visually-hidden"> Loading...</span>
      </div> </a></div>


      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
              <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D61551236967321&tabs=timeline&width=1000&height=430&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="100%" height="430" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
            </div>
            <div className="col-md-6 mt-3">
              <iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1455011553076541%2F&show_text=false&width=430&t=0" width="100%" height="436" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>

            </div>
          </div>
        </div>
      </div>
      <br />
      <hr />
      <br />
      <div className="album py-0">
        <div className="container">
          <center>
            <h1><b>Unicorn Aerocity| Plots Near Kolkata Airport</b></h1>
          </center>
        </div>
      </div>
      <div className="album py-0">
        <div className="container">
          <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/l4zhS9Rvnww"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <hr />
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/VS-wJDb0P5E"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="col-md-4 mt-3">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/WU3bvJ1NSnY"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="col-md-4 mt-3">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/KOHRNV_ny4U"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div className="album py-2">
        <div className="container">
          <center>


            <h1 style={{ color: "#095a67" }} className='mb-1'><b> Our Connectivity</b></h1>
            <p>Positioned at the center of rapid growth, delivering</p>
          </center>
        </div>
      </div>
      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
              <NearbyPlaces />
            </div>
            <div className="col-md-6 mt-3">
              <iframe className="iframe-fluid" width="100%" height="450" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=Unicorn%20Aerocity,%20MF72+CPR,%20Ganga%20Nagar%20Colony%20No%201,%20Madhyamgram,%20Domnagar%20P,%20West%20Bengal%20700052%20+(Unicorn%20Aerocity,%20MF72+CPR,%20Ganga%20Nagar%20Colony%20No%201,%20Madhyamgram,%20Domnagar%20P,%20West%20Bengal%20700052)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>


            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  )
}

export default Home